<!-- Main home Component-->
<!-- Loader -->
<div *ngIf="loading">
  <div class="loading">
    <div class="dot"></div>
    <div class="dot"></div>
    <div class="dot"></div>
    <div class="dot"></div>
    <div class="dot"></div>
  </div>
</div>
<!-- end of Loader-->
<ng-container *ngIf="!loading">
  <ng-container *ngIf="!role">
  NO USER
  </ng-container>
<!--If not subscribed, options to subscribe or subscription details, or pricing details-->
  <ng-container *ngIf="role === 'CUSTOMER'">
    <div class="wrapper ">
      <div>
        <h3 style="text-align: center;color: rgba(255, 0, 0, 0.774);"><b>{{x}}</b></h3>
        

        <div class="row" style="float: center;display: none;">
          <div class="col-md-3">
            <div class="card card-stats">
              <div class="card-header card-header-danger card-header-icon">
                <div class="card-icon">
                  <i class="material-icons">content_copy</i>
                </div>
                <p class="card-title"><b>Tickets Raised</b></p>
                <h3 class="card-title">{{raisedtickets}}</h3>
                <br><br>
                </div>
              <div class="card-footer">
                <!-- <div class="stats" *ngIf="unassignedTickets>0"> Condition to be changed
                  <i class="material-icons text-danger">warning</i>
                  <a href="javascript:;">Piling up...</a>
                </div> -->
              </div>
            </div>
          </div> 
          <div class="col-md-3">
            <div class="card card-stats">
              <div class="card-header card-header-warning card-header-icon">
                <div class="card-icon">
                  <i class="material-icons">store</i>
                </div>                    
                <p class="card-title"><b>Assigned Tickets</b></p>
                <p class="card-category">Total Pending</p>
                <h3 class="card-title">{{ assignedTickets_cust }}</h3>
                <p class="card-category">Pending >24 hours</p>
                <h3 class="card-title">{{ gt24assignedTickets }}</h3>
              </div>
              <div class="card-footer"></div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="card card-stats">
              <div class="card-header card-header-danger card-header-icon">
                <div class="card-icon">
                  <i class="material-icons">content_copy</i>
                </div>
                <p class="card-title"><b>Un-assigned Tickets</b></p>
                <p class="card-category">Total Pending</p>
                <h3 class="card-title">{{ unassignedTickets }}</h3>
                <p class="card-category">Pending >24 hours</p>
                <h3 class="card-title">{{ gt24unassignedTickets }}</h3>
              </div>
              <div class="card-footer">
                <!-- <div class="stats" *ngIf="unassignedTickets>0"> Condition to be changed
                  <i class="material-icons text-danger">warning</i>
                  <a href="javascript:;">Piling up...</a>
                </div> -->
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="card card-stats">
              <div class="card-header card-header-success card-header-icon">
                <div class="card-icon">
                  <i class="material-icons">info_outline</i>
                </div>
                <p class="card-title"><b>Resolved Tickets</b></p>
                <!-- <h3 class="card-title">{{cust_resolved_tickets}}</h3> -->
                <br><br><br>
              </div>
              <div class="card-footer"></div>
            </div>
          </div>
        </div>

        <!-- TO BE DONE -->
        <div class="content landing-page landing-page1">
          <div class="wrapper" style="padding: 0px 7%; margin: 0 auto;">

            <div class="section section-clients" style="text-align: center;">
              <TABLE WIDTH=100% BORDER=0 CELLPADDING=0 CELLSPACING=0 style="align-items: center;">
                <!-- <TR>
                  <TD COLSPAN=4>
                      <IMG (click)="open(mymodal)" SRC="/assets/images/SNAM THERMAL_TS.gif" WIDTH=100% HEIGHT=66>
                  </TD>
                  <TD>
                    <IMG SRC="/assets/images/spacer.gif" WIDTH=1 HEIGHT=66></TD>
                </TR> -->
                <!-- <TR>
                  <TD COLSPAN=4>
                    <IMG SRC="/assets/images/CBTAS-User-DB_02.gif" WIDTH=100% HEIGHT=117></TD>
                  <TD>
                    <IMG SRC="/assets/images/spacer.gif" WIDTH=1 HEIGHT=117></TD>
                </TR> -->
                <TR>
                  <TD>
                    <a [routerLink]="['/get-all-alloys']">
                    <IMG SRC="/assets/images/CBTAS-User-DB_03.gif" WIDTH=525 HEIGHT=64></a></TD>
                  <TD COLSPAN=3 ROWSPAN=8>
                    <!--<IMG SRC="/assets/images/CBTAS-User-DB_04.gif" WIDTH=375 HEIGHT=422></TD>-->
                  <TD>
                    <IMG SRC="/assets/images/spacer.gif" WIDTH=1 HEIGHT=64></TD>
                </TR>
                <TR>
                  <TD>
                    <a [routerLink]="['/view-all-graphs']">
                    <IMG SRC="/assets/images/CBTAS-User-DB_05.gif" WIDTH=525 HEIGHT=60></a></TD>
                  <TD>
                    <IMG SRC="/assets/images/spacer.gif" WIDTH=1 HEIGHT=60></TD>
                </TR>
                <TR>
                  <TD>
                    <IMG SRC="/assets/images/CBTAS-User-DB_06.gif" WIDTH=525 HEIGHT=1></TD>
                  <TD>
                    <IMG SRC="/assets/images/spacer.gif" WIDTH=1 HEIGHT=1></TD>
                </TR>
                <TR>
                  <TD>
                    <a [routerLink]="['/view-all-graphs']">
                    <IMG SRC="/assets/images/CBTAS-User-DB_07.gif" WIDTH=525 HEIGHT=58></a></TD>
                  <TD>
                    <IMG SRC="/assets/images/spacer.gif" WIDTH=1 HEIGHT=58></TD>
                </TR>
                <TR>
                  <TD>
                    <a [routerLink]="['/get-all-tickets']">
                    <IMG SRC="/assets/images/CBTAS-User-DB_08.gif" WIDTH=525 HEIGHT=62></a></TD>
                  <TD>
                    <IMG SRC="/assets/images/spacer.gif" WIDTH=1 HEIGHT=62></TD>
                </TR>
                <!-- <TR>
                  <TD>
                    <a [routerLink]="['/payment']">
                    <IMG SRC="/assets/images/CBTAS-User-DB_09.gif" WIDTH=525 HEIGHT=61></a></TD>
                  <TD>
                    <IMG SRC="/assets/images/spacer.gif" WIDTH=1 HEIGHT=61></TD>
                </TR> -->
                <TR>
                  <TD>
                    <a [routerLink]="['/get-transactions']">
                    <IMG SRC="/assets/images/CBTAS-User-DB_10.gif" WIDTH=525 HEIGHT=58></a></TD>
                  <TD>
                    <IMG SRC="/assets/images/spacer.gif" WIDTH=1 HEIGHT=58></TD>
                </TR>
            
                <!-- <TR>
                  <TD ROWSPAN=2>
                    <IMG SRC="/assets/images/CBTAS-User-DB_12.gif" WIDTH=166 HEIGHT=95></TD>
                  <TD>
                    <IMG SRC="/assets/images/CBTAS-User-DB_13.gif" WIDTH=154 HEIGHT=58></TD>
                  <TD ROWSPAN=2>
                    <IMG SRC="/assets/images/CBTAS-User-DB_14.gif" WIDTH=55 HEIGHT=95></TD>
                  <TD>
                    <IMG SRC="/assets/images/spacer.gif" WIDTH=1 HEIGHT=58></TD>
                </TR>
                <TR>
                  <TD>
                    <IMG SRC="/assets/images/CBTAS-User-DB_15.gif" WIDTH=154 HEIGHT=37></TD>
                  <TD>
                    <IMG SRC="/assets/images/spacer.gif" WIDTH=1 HEIGHT=37></TD>
                </TR> -->
              </TABLE>
                <!-- <div class="container text-center">
                    <h4 class="header-text">Welcome to SNAM</h4>
                    <p>
                        Thank you for using our services!<br>
                    </p>
                </div>
                <div class="container text-center" *ngIf="bankdetailsNeeded === true">
                <br>
                <mat-card style="margin: 0 auto; width: 50%; padding: 5%;">
                  <mat-card-header >
                    <mat-card-subtitle style="text-align: start; color: darkred;">Required!</mat-card-subtitle>
                    <mat-card-title style="width: 100%;">Please provide your bank details.</mat-card-title>
                  </mat-card-header>
                  <mat-card-content>
                    <p>

                    </p>
                  </mat-card-content>
                  <mat-card-actions>
                    <button mat-raised-button color="warn" routerLinkActive="active" [routerLink]='["/enter-banking-details"]'>UPDATE NOW</button>
                  </mat-card-actions>
                </mat-card>
              </div> -->
            </div>

            <div class="section">
              <div class="container" *ngIf="ticket">
                <h4 class="header-text text-center">Your Last Tickets</h4>
                <div class="row">
                    <div class="col-md-8" style="margin: auto; padding: 2em;">
                        <div class="card text-center card-blue">
                          <table class="table table-hover">
                              <tr>
                                <th scope="row" class="text-primary">Ticket ID</th>
                                <td>{{ ticket._id }}</td>
                              </tr>
                              <tr>
                                <th scope="row" class="text-primary">Your Message</th>
                                <td>{{ ticket.message[0]['message'] }}</td>
                              </tr>
                              <tr>
                                <th scope="row" class="text-primary">Created On</th>
                                <td>{{ ticket.createdAt }}</td>
                              </tr>
                              <tr>
                                <th scope="row" class="text-primary">Last Updated</th>
                                <td>{{ ticket.updatedAt }}</td>
                              </tr>
                              <tr>
                                <th scope="row" class="text-primary">Reply</th>
                                <td>
                                  <div *ngFor="let message of ticket.message">
                                    <li *ngIf="message['role']==='TECHEXPERT'">
                                      {{message['message']}}
                                    </li>
                                  </div>
                                </td>
                              </tr>
                          </table>
                          <button mat-raised-button color="accent" routerLinkActive="active" [routerLink]='["/get-all-tickets"]'>View All Tickets</button>
                        </div>
                      </div>
                  </div>
              </div>
              <div class="container" *ngIf="!ticket">
                <h4 class="header-text text-center">No Tickets to show</h4>
              </div>
            </div>
            <!-- <div class="section section-features">
                <div class="container">
                  <h4 class="header-text text-center">Services We Provide</h4>
                  <div class="row">
                      <div class="col-md-6" style="margin: auto;">
                          <div class="card text-center card-blue">
                              <div class="icon">
                                  <i class="pe-7s-graph1"></i>
                              </div>
                              <h4>FEATURE 1</h4>
                              <p>To be updated later.</p>
                          </div>
                      </div>
                      <div class="col-md-6" style="margin: auto;">
                        <div class="card text-center card-blue">
                            <div class="icon">
                                <i class="pe-7s-graph1"></i>
                            </div>
                            <h4>FEATURE 2</h4>
                            <p>To be updated later.</p>
                        </div>
                    </div>
                  </div>
                    <h4 class="header-text text-center">Our Pricing</h4>
                    <div class="row">
                        <div class="col-md-8" style="margin: auto;">
                            <div class="card text-center card-blue">
                                <div class="icon">
                                    <i class="pe-7s-graph1"></i>
                                </div>
                                <h4>Our affordable prices for you!</h4>
                                <p>To be updated once we have them</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div> -->

            <!-- <div class="section section-gray section-clients">
              <div class="container text-center">
                  <h1>Feel free to contact us!</h1>
                  <p>publicrelations@snampvt.com</p>
              </div>
            </div> -->
            </div>
        </div>
      </div>
    </div>

    <ng-template #mymodal let-modal>
      <div class="modal-header">
        Your notifications
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
          <span aria-hidden="true">×</span>
        </button>
      </div>
        <div class="modal-body">
          Todays Date: {{date}}<br>
          Current Balance: {{balance}}<br>
          Other Stuff: <br>
        </div>
        <div class="modal-footer">

        </div>
    </ng-template>

  </ng-container>

<!--Number of tickets assigned, yet to be assigned-->
  <ng-container *ngIf="role === 'MODERATOR'">
    <div class="wrapper ">
      <div>
        <h3 style="text-align: center;color: rgba(255, 0, 0, 0.774);"><b>{{x}}</b></h3>
        <div class="content" style="padding: 2% 10%;">
          <div class="container-fluid">
            <div class="row">
              <div class="col-md-4">
                <div class="card card-stats">
                  <div class="card-header card-header-danger card-header-icon">
                    <div class="card-icon">
                      <i class="material-icons">content_copy</i>
                    </div>
                    <p class="card-title"><b>Un-assigned Tickets</b></p>
                    <p class="card-category">Total Pending</p>
                    <h3 class="card-title">{{ unassignedTickets }}</h3>
                    <p class="card-category">Pending >24 hours</p>
                    <h3 class="card-title">{{ gt24unassignedTickets }}</h3>
                  </div>
                  <div class="card-footer">
                    <!-- <div class="stats" *ngIf="unassignedTickets>0"> Condition to be changed
                      <i class="material-icons text-danger">warning</i>
                      <a href="javascript:;">Piling up...</a>
                    </div> -->
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="card card-stats">
                  <div class="card-header card-header-warning card-header-icon">
                    <div class="card-icon">
                      <i class="material-icons">store</i>
                    </div>                    
                    <p class="card-title"><b>Assigned Tickets</b></p>
                    <p class="card-category">Total Pending</p>
                    <h3 class="card-title">{{ assignedTickets }}</h3>
                    <p class="card-category">Pending >24 hours</p>
                    <h3 class="card-title">{{ gt24assignedTickets }}</h3>
                  </div>
                  <div class="card-footer"></div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="card card-stats">
                  <div class="card-header card-header-success card-header-icon">
                    <div class="card-icon">
                      <i class="material-icons">info_outline</i>
                    </div>
                    <p class="card-category">Resolved Tickets</p>
                    <h3 class="card-title">{{ closedTickets }}</h3>
                    <br><br><br>
                  </div>
                  <div class="card-footer"></div>
                </div>
              </div>
            </div>
            <div class="row" style="text-align: center; " data-color="azure">
              <!-- <div class="col-lg-6 col-md-12"> -->
                <div class="card">
                  <div class="card-header card-header-warning">
                    <h4 class="card-title">Tech Experts</h4>
                  </div>
                  <div class="card-body table-responsive">
                    <table class="table table-hover">
                      <thead class="text-warning">
                        <th>ID</th>
                        <th>Name</th>
                      </thead>
                      <tbody>
                        <tr *ngFor="let expert of experts">
                          <td>{{ expert._id }}</td>
                          <td>{{ expert.fullName }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              <!-- </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

<!--Number of tickets resolved, left to be resolved, Monthly statistics, etc-->
  <ng-container *ngIf="role === 'TECHEXPERT'">
    <div class="wrapper ">
      <div>
        <h3 style="text-align: center;color: rgba(255, 0, 0, 0.774);"><b>{{x}}</b></h3>
        <div class="content" style="padding: 10% 25%;">
          <div class="container-fluid">
            <div class="row">
              <div class="col-md-6">
                <div class="card card-stats">
                  <div class="card-header card-header-warning card-header-icon">
                    <div class="card-icon">
                      <i class="material-icons">content_copy</i>
                    </div>
                    <p class="card-category">Total Pending Tickets</p>
                    <h3 class="card-title">{{ pending }}</h3>

                    <p class="card-category">Tickets Pending > 24 hours</p>
                    <h3 class="card-title">{{ gt24pending }}</h3>
                  </div>
                  
                  <div class="card-footer">
                    <!-- <div class="stats">
                      <i class="material-icons text-danger">warning</i>
                      <a href="javascript:;">Piling Up...</a>
                    </div> -->
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="card card-stats">
                  <div class="card-header card-header-success card-header-icon">
                    <div class="card-icon">
                      <i class="material-icons">store</i>
                    </div>
                    <p class="card-category">Resolved Tickets</p>
                    <h3 class="card-title">{{ resolved }}</h3>
                    <br><br><br>
                  </div>
                  <div class="card-footer">
                    <!-- <div class="stats">
                      <i class="material-icons">date_range</i>5 in Last 24 Hours
                    </div> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

</ng-container>
<!-- end of Home page-->
